import DefaultMonitoringReport from "src/components/feature/MonitoringReport";

const MonitoringReport = () => {
  return <DefaultMonitoringReport />;
};

export default MonitoringReport;
